import { MappedClass, MappedProperty, MappedPropertyCurrency } from '@h5s/util-object';
import Big from 'big.js';
import { ResourceReferenceType } from './resource-reference-type';

@MappedClass()
export class QueryResource {
  @MappedProperty()
  ascending = true;

  @MappedProperty()
  available?: boolean;

  @MappedPropertyCurrency()
  basePriceLower?: Big;

  @MappedPropertyCurrency()
  basePriceUpper?: Big;

  @MappedProperty()
  costCenterId?: number;

  @MappedProperty()
  defaultPriceListId?: number;

  @MappedProperty()
  defaultPriceListIdIn?: number[];

  @MappedProperty()
  departmentId?: number;

  @MappedProperty()
  description?: string;

  @MappedProperty()
  descriptionDe?: string;

  @MappedProperty()
  descriptionEn?: string;

  @MappedProperty()
  descriptionEnLike?: string;

  @MappedProperty()
  descriptionEnStart?: string;

  @MappedProperty()
  descriptionEs?: string;

  @MappedProperty()
  descriptionFr?: string;

  @MappedProperty()
  descriptionLike?: string;

  @MappedProperty()
  descriptionStart?: string;

  @MappedProperty()
  exportCode?: string;

  @MappedProperty()
  id?: number;

  @MappedProperty()
  idIn?: number[];

  @MappedProperty()
  limit?: number;

  @MappedProperty()
  notesEnLike?: string;

  @MappedProperty()
  notesLike?: string;

  @MappedProperty()
  offset?: number;

  @MappedProperty()
  orderBy?: string;

  @MappedProperty()
  priceListId?: number;

  @MappedProperty()
  priceListIdIn?: number[];

  @MappedProperty()
  type?: ResourceReferenceType;

  @MappedPropertyCurrency()
  vat?: Big;

  @MappedProperty()
  vatRateId?: number;

  constructor(fields: Partial<QueryResource>) {
    Object.assign(this, fields);
  }
}
